import React, {useMemo, useState} from "react";
import {FormattedMessage} from 'react-intl';
import Search, {SearchInputType} from '@components/custom/Search';
import moment from 'moment';
import {SelectionMode, IntervalOptions, Interval} from '@models/index';
import {SubscriptionStatus, SubscriptionStatusOptions} from "@models/subscription";
import ClientSelection from "@components/clients/Selection"
import PackagesSelection from "@components/packages/Selection"
import {PaymentGatewayOptions} from '@models/paymentGateway';
import __i18n from "../../intl/__i18n";
import {REGEX_PATTERNS} from '../../constants/regex';


interface SearchInputProps {
  search: (filter: object) => any;
  form: any;
  intl: any;
}

const SubscriptionsReportSearch: React.FC<SearchInputProps> = props => {
  const {search} = props;
  const [startDate, setStartDate] = useState(null)
  
  const disabledEndDateRange = useMemo(() => {
    return startDate ? [{
      disabled: true,
      start: moment("1970/01/01"),
      end: moment(startDate).add(-1, "d")
    }] : null
  }, [startDate]);
  
  const inputs = [{
    name: "client_id",
    label: <FormattedMessage id="app.client" defaultMessage={`Client`}/>,
    component: ClientSelection,
    size: 8,
    type: SearchInputType.SELECT,
    InputProps: {
      mode: SelectionMode.DEFAULT,
    }
  },{
    name: "package_id",
    label: <FormattedMessage id="app.package" defaultMessage={`Package`}/>,
    component: PackagesSelection,
    size: 8,
  },{
    name: "gateway",
    label: __i18n("Payment Gateway"),
    type: SearchInputType.SELECT,
    options: PaymentGatewayOptions,
    selectionType : SelectionMode.DEFAULT,
    size: 8
  },{
    name: "msisdn",
    label: <FormattedMessage id="app.mobile" defaultMessage={`Mobile`}/>,
    size: 8,
    type: SearchInputType.TEXT,
    validationRules:[{
      pattern: REGEX_PATTERNS.MOBILE,
      message: __i18n("{value} is not valid.", {
        value : __i18n("Value")
      })
    }],
    InputProps:{
      placeholder : "98912111111"
    }
  },{
    name: "status",
    label: <FormattedMessage id="app.status" defaultMessage={`Status`}/>,
    type: SearchInputType.SELECT,
    options: SubscriptionStatusOptions,
    selectionType : SelectionMode.DEFAULT,
    size: 8,
  },{
    name: "interval",
    label: <FormattedMessage id="app.interval" defaultMessage={`Interval`}/>,
    type: SearchInputType.SELECT,
    options: IntervalOptions,
    selectionType : SelectionMode.DEFAULT,
    size: 8,
    InputProps:{
      defaultValue : Interval.Day
    }
  },{
    name: "from",
    label: <FormattedMessage id="app.from" defaultMessage={`From`}/>,
    type: SearchInputType.DATE,
    size: 8,
    InputProps:{
      onChange: (date) => setStartDate(date),
    }
  }, {
    name: "to",
    label: <FormattedMessage id="app.to" defaultMessage={`To`}/>,
    type: SearchInputType.DATE,
    size: 8,
    InputProps:{
      ranges: disabledEndDateRange
    }
  },{
    name: "expire",
    label: <FormattedMessage id="app.expiration_date" defaultMessage={`Expire Date`}/>,
    type: SearchInputType.DATE,
    size: 8,
    InputProps:{
      ranges: disabledEndDateRange
    }
  },];
  
  return(
    <Search
      inputs={inputs}
      search={search}
      hasClearButton={true}
      searchOnChange={false}/>
  )
};


export default SubscriptionsReportSearch;